<template>
  <div class="register-step result">
    <div class="success-animation">
      <div class="checkmark-circle">
        <span class="checkmark">✓</span>
      </div>
    </div>
    <h2>注册申请已提交</h2>
    <p class="result-desc">您的注册申请已提交，请等待审核</p>
    <p class="result-desc sub">审核通过后将以短信形式通知您</p>
    
    <div class="result-info">
      <div class="info-item">
        <span class="label"><i class="el-icon-user"></i> 申请人</span>
        <span class="value">{{ name }}</span>
      </div>
      <div class="info-item">
        <span class="label"><i class="el-icon-mobile-phone"></i> 手机号</span>
        <span class="value">{{ phone }}</span>
      </div>
      <div class="info-item">
        <span class="label"><i class="el-icon-office-building"></i> 机构名称</span>
        <span class="value">{{ orgName }}</span>
      </div>
      <div class="info-item">
        <span class="label"><i class="el-icon-location"></i> 工作场站</span>
        <span class="value">{{ workArea || '未选择' }}</span>
      </div>
    </div>
    
    <div class="contact-tip">
      <i class="el-icon-service tip-icon"></i>
      <span>如有疑问，请联系客服：4000490016</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResultStep',
  props: {
    name: { type: String, default: '' },
    phone: { type: String, default: '' },
    orgName: { type: String, default: '' },
    workArea: { type: String, default: '' }
  }
}
</script>

<style scoped>
.register-step {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-radius: 24px;
  padding: 20px 16px;
  box-shadow: 
    0 20px 60px rgba(0, 0, 0, 0.15),
    0 0 0 1px rgba(255, 255, 255, 0.5) inset;
  animation: slideUp 0.5s ease-out;
  position: relative;
  overflow: hidden;
}

@keyframes slideUp {
  from { opacity: 0; transform: translateY(30px); }
  to { opacity: 1; transform: translateY(0); }
}

.register-step.result {
  text-align: center;
  padding: 24px 16px;
}

.success-animation {
  margin-bottom: 16px;
}

.checkmark-circle {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: linear-gradient(135deg, #7EBF50 0%, #6AAD40 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  animation: scaleIn 0.5s ease-out 0.2s both;
  box-shadow: 0 10px 30px rgba(126, 191, 80, 0.4);
}

@keyframes scaleIn {
  from { transform: scale(0); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}

.checkmark {
  color: #fff;
  font-size: 32px;
  font-weight: bold;
  animation: checkmarkDraw 0.4s ease-out 0.6s both;
}

@keyframes checkmarkDraw {
  from { opacity: 0; transform: scale(0.5); }
  to { opacity: 1; transform: scale(1); }
}

.result h2 {
  font-size: 22px;
  color: #1a1a2e;
  margin: 0 0 12px;
  font-weight: 700;
}

.result-desc {
  font-size: 15px;
  color: #666;
  margin: 0 0 6px;
}

.result-desc.sub {
  font-size: 13px;
  color: #999;
}

.result-info {
  background: linear-gradient(135deg, #f8f9fa 0%, #fff 100%);
  border-radius: 12px;
  padding: 14px;
  margin: 16px 0;
  text-align: left;
  border: 1px solid #e8e8ed;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
}

.info-item:last-child {
  border-bottom: none;
}

.info-item .label {
  color: #666;
  font-size: 14px;
}

.info-item .value {
  color: #1a1a2e;
  font-size: 14px;
  font-weight: 600;
}

.contact-tip {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 13px;
  color: #8e8e93;
  background: linear-gradient(135deg, #f0f0f5 0%, #f8f8fa 100%);
  padding: 12px 16px;
  border-radius: 12px;
  margin-top: 8px;
}

.tip-icon {
  font-size: 16px;
}

@media screen and (max-width: 480px) {
  .register-step {
    padding: 20px 16px;
    border-radius: 20px;
  }

  .register-step.result {
    padding: 30px 16px;
  }

  .checkmark-circle {
    width: 70px;
    height: 70px;
  }

  .checkmark {
    font-size: 35px;
  }

  .result h2 {
    font-size: 20px;
  }
}

@media screen and (max-width: 360px) {
  .register-step {
    padding: 16px 12px;
  }

  .checkmark-circle {
    width: 60px;
    height: 60px;
  }

  .checkmark {
    font-size: 30px;
  }
}
</style>
